"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function isMobileDevice() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}
var isMobile = isMobileDevice();
var initScale = 3;
var viewerId = "mobileImageViewer";
var bodyContainer = document.body;
var CustomMainProductSlider = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustomMainProductSlider, _HTMLElement);
  function CustomMainProductSlider() {
    var _this;
    _classCallCheck(this, CustomMainProductSlider);
    _this = _callSuper(this, CustomMainProductSlider);
    _this.disabledCursorTrack = false;
    return _this;
  }
  _createClass(CustomMainProductSlider, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {}
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.initSwiper();
      var container = this.querySelector(".swiper-container");
      this.swiperContainer = container;
      this.customCursor = this.querySelector(".custom-cursor");
      this.swiperContainer.addEventListener("mousemove", this.handleMouseMove.bind(this));
      this.swiperContainer.addEventListener("mouseleave", this.handleMouseLeave.bind(this));
      var zoom;
      var renderImageViewer = function renderImageViewer(imageUrl) {
        bodyContainer.classList.add("overflow-hidden");
        var content = document.createElement("div");
        content.setAttribute("id", viewerId);
        content.setAttribute("class", viewerId);
        content.setAttribute("style", "position: fixed;left:0;top:0;width:100vw;height:100vh;z-index:1000000;");
        var mobileCursor = document.createElement("div");
        mobileCursor.setAttribute("class", "mobile-custom-cursor");
        mobileCursor.innerHTML = "\n      <div class=\"cursor-x\"></div>\n      <div class=\"cursor-y\"></div>\n  ";
        mobileCursor.addEventListener("click", function () {
          removeImageViewer();
        });
        var image = document.createElement("img");
        image.setAttribute("src", imageUrl);
        content.appendChild(mobileCursor);
        content.appendChild(image);
        zoom = new PinchZoom(image, {
          tapZoomFactor: 3,
          maxZoom: 3,
          minZoom: 1,
          useDoubleTap: true,
          verticalPadding: 0,
          horizontalPadding: 0,
          center: true
        });
        var center = {
          x: window.innerWidth / 2,
          y: window.innerHeight / 2
        };
        bodyContainer.appendChild(content);
        image.addEventListener("load", function () {
          setTimeout(function () {
            zoom.initScale(1.25, center);
          }, 10);
        });
      };
      var removeImageViewer = function removeImageViewer() {
        zoom.destroy();
        bodyContainer.classList.remove("overflow-hidden");
        document.getElementById(viewerId).remove();
      };
      var slides = this.querySelectorAll(".swiper-slide");
      slides.forEach(function (slide) {
        var image = slide.querySelector(".cover-image");
        var recover = function recover() {
          image.style.transformOrigin = "0 0";
          image.style.transform = "matrix(1, 0, 0,1, 0,0)";
        };
        var mouseMove = function mouseMove(e) {
          var bound = slide.getBoundingClientRect();
          var x = e.clientX - bound.left;
          var y = e.clientY - bound.top;
          var lastX = -x * (initScale - 1);
          var lastY = -y * (initScale - 1);
          image.style.transformOrigin = "0 0";
          image.style.transform = "matrix(".concat(initScale, ", 0, 0, ").concat(initScale, ", ").concat(lastX, ", ").concat(lastY, ")");
        };
        if (!isMobile) {
          slide.addEventListener("mouseleave", function () {
            recover();
          });
          slide.addEventListener("mouseleave", function () {
            slide.removeEventListener("mousemove", mouseMove);
            _this2.deactiveCursor();
          });
        }
        image.addEventListener("click", function (e) {
          e.preventDefault();
          if (!isMobile) {
            if (image.classList.contains("active")) {
              image.classList.remove("active");
              _this2.deactiveCursor();
              slide.removeEventListener("mousemove", mouseMove);
              recover();
            } else {
              image.classList.add("active");
              _this2.activeCursor();
              slide.addEventListener("mousemove", mouseMove);
              mouseMove(e);
            }
          } else {
            renderImageViewer(image.src);
          }
        });
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {}
  }, {
    key: "initSwiper",
    value: function initSwiper() {
      var _this3 = this;
      var target = this.querySelector(".swiper");
      var swiper = new Swiper(target, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
        direction: "vertical",
        loop: false
      }, "direction", "horizontal"), "allowTouchMove", true), "slidesPerView", 1), "zoom", false), "keyboard", {
        enabled: true,
        onlyInViewport: true
      }), "mousewheel", {
        enabled: false,
        releaseOnEdges: true
      }), "pagination", {
        el: ".swiper-pagination",
        enabled: true
      }), "navigation", {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        enabled: false
      }), "breakpoints", {
        750: {
          slidesPerView: "auto",
          spaceBetween: 4,
          pagination: {
            enabled: false
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
            enabled: true
          }
        }
      }), "on", {
        init: function init() {
          target.classList.add("swiper-initialized");
          console.log("swiper initialized");
          var next = document.querySelector(".swiper-button-next");
          next.addEventListener("mouseover", function () {
            _this3.disabledCursorTrack = true;
            _this3.hideCursor();
          });
          next.addEventListener("mouseout", function () {
            _this3.disabledCursorTrack = false;
            _this3.showCursor();
          });
          var prev = document.querySelector(".swiper-button-prev");
          prev.addEventListener("mouseover", function () {
            _this3.disabledCursorTrack = true;
            _this3.hideCursor();
          });
          prev.addEventListener("mouseout", function () {
            _this3.disabledCursorTrack = false;
            _this3.showCursor();
          });
        }
      }));
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(e) {
      this.trackCursor(e);
    }
  }, {
    key: "handleMouseLeave",
    value: function handleMouseLeave(e) {
      this.hideCursor();
    }
  }, {
    key: "trackCursor",
    value: function trackCursor(e) {
      e.preventDefault();
      e.stopPropagation();
      if (this.disabledCursorTrack) {
        return;
      }
      var rect = this.swiperContainer.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      this.showCursor();
      this.followCustomCursor(x, y);
    }
  }, {
    key: "followCustomCursor",
    value: function followCustomCursor(x, y) {
      this.customCursor.style.left = x + "px";
      this.customCursor.style.top = y + "px";
    }
  }, {
    key: "showCursor",
    value: function showCursor() {
      this.customCursor.classList.add("show");
    }
  }, {
    key: "hideCursor",
    value: function hideCursor() {
      this.customCursor.classList.remove("show");
    }
  }, {
    key: "activeCursor",
    value: function activeCursor() {
      this.customCursor.classList.add("active");
    }
  }, {
    key: "deactiveCursor",
    value: function deactiveCursor() {
      this.customCursor.classList.remove("active");
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["product-id"];
    }
  }]);
  return CustomMainProductSlider;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get("custom-main-product-slider")) {
  customElements.define("custom-main-product-slider", CustomMainProductSlider);
}